import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admindashboard/_layout/transactions")({
  validateSearch: z.object({
    q: z.string().optional(),
    page: z.int().min(0).default(0).optional(),
    pageSize: z.int().max(100).min(25).default(50),
    sortBy: z.string().optional().default("status"),
    sortDir: z.enum(["asc", "desc"]).optional().default("asc"),
    status: z.enum(["UNPAID", "PAID", "REFUNDED"]).optional(),
    users: z.array(z.uuid()).optional(),
    staff: z.array(z.uuid()).optional(),
    chargedAtFrom: z.string().optional(),
    chargedAtTo: z.string().optional(),
  }),
});
